'use client';

/**
 * MarketingNav with the session user resolved CLIENT-side. The layout
 * must stay free of `cookies()` so the marketing tree prerenders
 * statically (anon TTFB = serve a file); signed-in visitors see the
 * Sign-in cluster for one round-trip before it swaps to their pill —
 * cosmetic-only, and the tradeoff that keeps `/` static.
 */
import { MarketingNav, type MarketingNavUser } from '@repo/marketing-ui';
import { useEffect, useState } from 'react';

export function NavWithUser() {
  const [user, setUser] = useState<MarketingNavUser | null>(null);

  useEffect(() => {
    const ctrl = new AbortController();
    fetch('/api/nav-user', { signal: ctrl.signal })
      .then((res) => (res.ok ? res.json() : null))
      .then((body: { user?: MarketingNavUser | null } | null) => {
        if (body?.user) setUser(body.user);
      })
      .catch(() => {
        // Logged-out cluster is the correct fallback for any failure.
      });
    return () => ctrl.abort();
  }, []);

  return <MarketingNav user={user} />;
}
